import type { OnBeforeRouteSync } from 'vike/types';
import { getPageContextSerializedInHtml } from "@/services/pageContextInHTML";
import { modifyQueryString } from "@/services/utils";
import {get as pathGet} from "@irrelon/path";

const onBeforeRoute: OnBeforeRouteSync = (pageContext): ReturnType<OnBeforeRouteSync> => {
	if (typeof window === "undefined") {
		return { pageContext: {} };
	}

	const existingContextInHTML = getPageContextSerializedInHtml() || {};
	const location = pathGet(existingContextInHTML, "query.location");
	const language = pathGet(existingContextInHTML, "query.language");
	const channel = pathGet(existingContextInHTML, "query.channel");

	const newData = {
		language,
		location,
		channel,
	};

	const _urlRewrite = modifyQueryString(pageContext.urlOriginal, newData, "overwrite");

	return {
		pageContext: {
			// @ts-ignore
			_urlRewrite,
			query: {
				...pageContext.query,
				language,
				location,
				channel
			}
		}
	}
};

export { onBeforeRoute };
